import { http } from "../api/http";

export const secretService = {
  updateConnectorSecret,
  retrieveConnectorSecret,
};

async function updateConnectorSecret(data) {
  let url = "/clientconnector/updateConnectorSecret";

  return await http.post(url, data).then((response) => {
    return response;
  });
}

async function retrieveConnectorSecret(data) {
  let url = "/clientconnector/retrieveConnectorSecret";

  return await http.post(url, data).then((response) => {
    return response;
  });
}
